module.exports = __webpack_public_path__ + "img/119.66d2889e.jpg";